import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  FaPhoneAlt,
  FaUser,
  FaEnvelope,
  FaTimes,
  FaCheckCircle,
  FaCalendarAlt,
  FaClock,
  FaHome,
  FaCar,
} from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import Navbardesign from "../Components/Navbar";
import Footer from "../Components/FooterDomain/Footerdata";
import ContactBar from "../Components/Fixedpossion/Fixedposion";
import ProjectDetailMAintaoin from "../Components/Projectcard/Maincarddesign";
import MithaHarithamProject from "../Components/Projectcard/Secondmaintain";
import ProjectFloorplans from "../Components/Projectcard/foreplan";
import ProjectGallery from "../Components/Projectcard/GalleryPlan";
import ProjectSection from "../Components/Projectcard/Projectdesign";
import PropertyDetails from "../Components/Projectcard/PropertyDetails";

const ProjectSepartedProjectPage = () => {
  const { id } = useParams();
  const projectId = Number(id);

  const [showModal, setShowModal] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const contactTimeOptions = [
    { value: "Morning", label: "Morning" },
    { value: "Afternoon", label: "Afternoon" },
    { value: "Evening", label: "Evening" }
  ];

  const timelineOptions = [
    { value: "Immediate", label: "Immediate" },
    { value: "3-6 Months", label: "3-6 Months" },
    { value: "6+ Months", label: "6+ Months" }
  ];

  const siteVisitOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" }
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    note: "",
    contactTime: "",
    readyToBuy: "",
    siteVisit: "",
    preferred_time: "",
    ready_to_buy_timeline: "",
    site_visit_required: ""
  });

  useEffect(() => {
    if (!projectId) return;
    const sendProjectView = async () => {
      try {
        await axios.post(
          "https://mithahomesfrontend.pemixcels.com/api/enquired/project/view",
          { projectId }
        );
      } catch (err) {
        console.error("Project view API error", err);
      }
    };
    sendProjectView();
  }, [projectId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const backendFieldMap = {
      contactTime: "preferred_time",
      readyToBuy: "ready_to_buy_timeline",
      siteVisit: "site_visit_required"
    };

    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(backendFieldMap[name] ? { [backendFieldMap[name]]: value } : {})
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone) {
      alert("Please fill in all required fields");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        project_id: projectId,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        note: formData.note || "",
        preferred_time: formData.preferred_time || "",
        ready_to_buy_timeline: formData.ready_to_buy_timeline || "",
        site_visit_required: formData.site_visit_required || ""
      };

      const res = await axios.post(
        "https://mithahomesfrontend.pemixcels.com/api/enquired/enquiry",
        payload
      );

      if (res.data?.success) {
        setShowModal(false);
        setSuccessPopup(true);
        setFormData({
          name: "", email: "", phone: "", note: "",
          contactTime: "", readyToBuy: "", siteVisit: "",
          preferred_time: "", ready_to_buy_timeline: "", site_visit_required: ""
        });
        setTimeout(() => setSuccessPopup(false), 2200);
      }
    } catch (error) {
      alert("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbardesign />
      <div style={{ paddingTop: '80px' }}>
        <ProjectDetailMAintaoin />
        <MithaHarithamProject />
        <ProjectFloorplans />
        <ProjectGallery />
        <PropertyDetails />
        <ProjectSection />
      </div>

      <Footer />
      <ContactBar />

      {/* ================= FLOATING BUTTON ================= */}
      <button className="interested-btn" onClick={() => setShowModal(true)}>
        <FaPhoneAlt className="pulse" />
        <span className="btn-text">I am Interested</span>
      </button>

      {/* ================= MODAL ================= */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <button className="close-btn-new" onClick={() => setShowModal(false)}>
              <FaTimes /> 
            </button>

            <div className="modal-header">
              <h3>Property Enquiry Form</h3>
              <p className="modal-subtitle">Fill in the details and we'll get back to you shortly</p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-section">
                <h4 className="section-title"><FaUser /> Personal Information</h4>
                <div className="input-group">
                  <FaUser className="input-icon" />
                  <input name="name" placeholder="Your Full Name *" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="input-group">
                  <FaEnvelope className="input-icon" />
                  <input name="email" type="email" placeholder="Email Address *" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="input-group">
                  <FaPhoneAlt className="input-icon" />
                  <input name="phone" type="tel" placeholder="Phone Number *" value={formData.phone} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-section">
                <div className="radio-group">
                  <label className="radio-group-label"><FaClock className="label-icon" /> Preferred Time</label>
                  <div className="radio-options">
                    {contactTimeOptions.map((opt) => (
                      <label key={opt.value} className="radio-label">
                        <input type="radio" name="contactTime" value={opt.value} checked={formData.contactTime === opt.value} onChange={handleChange} />
                        <span className="radio-text">{opt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="radio-group">
                  <label className="radio-group-label"><FaCalendarAlt className="label-icon" /> Timeline</label>
                  <div className="radio-options">
                    {timelineOptions.map((opt) => (
                      <label key={opt.value} className="radio-label">
                        <input type="radio" name="readyToBuy" value={opt.value} checked={formData.readyToBuy === opt.value} onChange={handleChange} />
                        <span className="radio-text">{opt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
                    <div className="radio-group">
                  <label className="radio-group-label">
                    <FaCar className="label-icon" />
                    Site Visit Required
                  </label>
                  <div className="radio-options">
                    {siteVisitOptions.map((option) => (
                      <label key={option.value} className="radio-label">
                        <input
                          type="radio"
                          name="siteVisit"
                          value={option.value}
                          checked={formData.siteVisit === option.value}
                          onChange={handleChange}
                          className="radio-input"
                          id={`visit-${option.value}`}
                        />
                        <span className="radio-custom"></span>
                        <span className="radio-text">{option.label}</span>
                      </label>
                    ))}
                  </div>
                 
                </div>
              </div>

              <div className="form-section">
                <h4 className="section-title"><FaHome /> Property Preferences</h4>
                <div className="input-group">
                  <textarea name="note" placeholder="Requirements..." value={formData.note} onChange={handleChange} rows="3" className="note-textarea" />
                </div>
              </div>

              <div className="form-footer">
                <button className="submit-btn" disabled={loading}>
                  {loading ? <AiOutlineLoading3Quarters className="spin" /> : "Submit Enquiry"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ================= SUCCESS POPUP ================= */}
      {successPopup && (
        <div className="success-overlay">
          <div className="success-box">
            <FaCheckCircle className="success-icon" />
            <h3>Thank You!</h3>
            <p>Enquiry Submitted Successfully</p>
          </div>
        </div>
      )}

      <style>{`
        /* DESKTOP STYLES */
        .interested-btn {
          position: fixed;
          bottom: 90px;
          left: 30px;
          background: linear-gradient(135deg, #e25e27, #ff8c42);
          color: #fff;
          padding: 14px 28px;
          border-radius: 50px;
          border: none;
          font-weight: 700;
          display: flex;
          gap: 12px;
          align-items: center;
          cursor: pointer;
          z-index: 9999;
          box-shadow: 0 10px 25px rgba(226, 94, 39, 0.4);
          transition: all 0.3s ease;
        }

        .interested-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 30px rgba(226, 94, 39, 0.5);
        }

        .btn-text {
          font-size: 15px;
        }

        .pulse { 
          animation: pulse 2s infinite; 
          font-size: 18px;
        }
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }

        /* MODAL STYLING */
        .modal-overlay { 
          position: fixed; 
          inset: 0; 
          background: rgba(0,0,0,0.7); 
          display: flex; 
          justify-content: center; 
          align-items: center; 
          z-index: 10000; 
          backdrop-filter: blur(4px); 
          padding: 15px;
        }
        
        .modal-box { 
          background: #fff; 
          width: 90%; 
          max-width: 500px; 
          border-radius: 20px; 
          overflow: hidden; 
          position: relative;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
        }
        
        .modal-header { 
          background: #e25e27; 
          color: white; 
          padding: 20px; 
          text-align: center; 
        }
        
        .modal-subtitle {
          margin-top: 5px;
          opacity: 0.9;
          font-size: 14px;
        }
        
        form { 
          padding: 20px; 
          overflow-y: auto;
          flex: 1;
        }
        
        .close-btn-new { 
          position: absolute; 
          top: 15px; 
          right: 15px; 
          background: none; 
          border: none; 
          color: white; 
          font-size: 20px; 
          cursor: pointer; 
          z-index: 1;
        }

        /* FORM STYLING */
        .form-section {
          margin-bottom: 25px;
        }
        
        .section-title {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 15px;
          color: #333;
          font-size: 16px;
        }
        
        .input-group { 
          display: flex; 
          align-items: center; 
          border: 1px solid #ddd; 
          padding: 12px; 
          border-radius: 10px; 
          margin-bottom: 15px;
          transition: border-color 0.3s;
        }
        
        .input-group:focus-within {
          border-color: #e25e27;
        }
        
        .input-icon { 
          color: #e25e27; 
          margin-right: 10px; 
          min-width: 20px;
        }
        
        .input-group input, .note-textarea { 
          border: none; 
          outline: none; 
          width: 100%; 
          font-size: 15px;
          background: transparent;
        }
        
        .note-textarea {
          resize: vertical;
          font-family: inherit;
        }
        
        /* RADIO GROUPS */
        .radio-group {
          margin-bottom: 20px;
        }
        
        .radio-group-label {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          font-weight: 500;
          color: #444;
        }
        
        .label-icon {
          color: #e25e27;
        }
        
        .radio-options { 
          display: flex; 
          gap: 10px; 
        }
        
        .radio-label { 
          flex: 1; 
          border: 1px solid #ddd; 
          padding: 12px; 
          border-radius: 8px; 
          text-align: center; 
          cursor: pointer; 
          transition: all 0.3s;
        }
        
        .radio-label:hover {
          border-color: #e25e27;
          background: rgba(226, 94, 39, 0.05);
        }
        
        .radio-label input {
          display: none;
        }
        
        .radio-text {
          display: block;
          font-size: 14px;
        }
        
        .radio-label input:checked + .radio-text {
          color: #e25e27;
          font-weight: 500;
        }
        
        .radio-label input:checked ~ .radio-text {
          color: #e25e27;
          font-weight: 500;
        }
        
        .radio-label input:checked {
          background: #e25e27;
        }
        
        /* SUBMIT BUTTON */
        .submit-btn { 
          width: 100%; 
          background: #e25e27; 
          color: #fff; 
          padding: 15px; 
          border: none; 
          border-radius: 10px; 
          font-weight: bold; 
          font-size: 16px;
          cursor: pointer;
          transition: background 0.3s;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }
        
        .submit-btn:hover:not(:disabled) {
          background: #d1541e;
        }
        
        .submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        
        .spin {
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* SUCCESS POPUP */
        .success-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 10001;
          backdrop-filter: blur(4px);
        }
        
        .success-box {
          background: white;
          padding: 40px 30px;
          border-radius: 20px;
          text-align: center;
          max-width: 350px;
          width: 90%;
          animation: fadeIn 0.3s ease;
        }
        
        .success-icon {
          font-size: 60px;
          color: #28a745;
          margin-bottom: 15px;
        }
        
        .success-box h3 {
          color: #333;
          margin-bottom: 10px;
        }
        
        .success-box p {
          color: #666;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }

        /* MOBILE RESPONSIVE FIXES */
        @media (max-width: 768px) {
          .interested-btn {
            left: 50%;
            transform: translateX(-50%);
            bottom: 20px;
            width: 90%;
            max-width: 350px;
            justify-content: center;
            padding: 16px 20px;
            border-radius: 50px;
            font-size: 16px;
            box-shadow: 0 5px 20px rgba(226, 94, 39, 0.4);
            white-space: nowrap;
          }
          
          .interested-btn:hover {
            transform: translateX(-50%) translateY(-2px);
          }

          .btn-text {
            display: inline !important;
            font-size: 15px;
          }

          .pulse {
            font-size: 18px;
          }

          .modal-overlay {
            padding: 10px;
            align-items: flex-end;
          }
          
          .modal-box {
            width: 100%;
            max-height: 85vh;
            border-radius: 20px 20px 0 0;
            margin-bottom: 0;
          }
          
          form {
            padding: 15px;
          }
          
          .modal-header {
            padding: 15px;
          }
          
          .modal-header h3 {
            font-size: 18px;
          }
          
          .radio-options {
            flex-direction: column;
          }
          
          .radio-label {
            padding: 14px;
          }
          
          .input-group {
            padding: 14px;
          }
          
          .success-box {
            width: 85%;
            padding: 30px 20px;
          }
          
          .success-icon {
            font-size: 50px;
          }
        }

        @media (max-width: 480px) {
          .interested-btn {
            width: 200px;
            margin-bottom: 40px;
            padding: 14px 16px;
          }
          
          .btn-text {
            font-size: 14px;
          }
          
          .section-title {
            font-size: 15px;
          }
          
          .radio-group-label {
            font-size: 14px;
          }
        }

        /* For very small screens */
        @media (max-width: 360px) {
          .interested-btn {
            font-size: 14px;
            padding: 12px 16px;
          }
          
          .btn-text {
            font-size: 13px;
          }
        }
      `}</style>
    </>
  );
};

export default ProjectSepartedProjectPage;